<template>
  <application-layout>
    <v-main>
      <v-form
        ref="editFeatureForm"
        @submit.prevent="submitEditFeatureForm"
      >
        <v-container>
          <v-row>
            <v-col cols="12" sm="4">
              <v-select
                data-testid="feature-edit-category-select"
                class="feature-edit-category-select"
                label="Category"
                :items="featureCategories"
                v-model="currentFeature.category"
                clearable
                filled
              />
            </v-col>
            <v-col cols="12" sm="4">
              <app-input
                data-testid="feature-edit-text-input"
                class="feature-edit-text-input"
                :type="'text'"
                label="Feature Text"
                v-model.trim="currentFeature.text"
                :rules="{ required: true }"
                :useValidation="true"
              />
            </v-col>
            <v-col cols="12" sm="4">
              <v-select
                data-testid="feature-edit-icon-select"
                class="feature-edit-icon-select"
                label="Icon"
                :items="availableIcons"
                v-model.trim="currentFeature.icon"
                clearable
                filled
              >
                <template slot="selection" slot-scope="data">
                  <v-icon>{{ data.item }}</v-icon>
                </template>

                <template slot="item" slot-scope="data">
                  <v-icon>{{ data.item }}</v-icon> &nbsp;&nbsp;&nbsp;{{ data.item }}
                </template>
              </v-select>
            </v-col>
            <v-col cols="12">
              <v-btn
                data-testid="feature-edit-cancel-btn"
                class="feature-edit-cancel-btn error mr-3 ml-0"
                @click="() => { this.$router.back(); }"
              >
                Cancel
              </v-btn>
              <v-btn
                data-testid="feature-edit-save-btn"
                class="feature-edit-save-btn"
                color="primary"
                type="submit"
                :loading="loadingState.includes('updating feature')"
                :disabled="!validFields"
              >
                Save
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </v-main>
  </application-layout>
</template>

<script>
import ApplicationLayout from "@/layouts/ApplicationLayout.vue";

export default {
  data() {
    return {};
  },

  computed: {
    availableIcons() {
      return this.$store.state.facilityFeature.availableIcons;
    },
    currentFeature: {
      get() {
        return this.$store.state.facilityFeature.currentFeature;
      },
      set(newValue) {
        this.$store.commit("setCurrentFeature", newValue);
      }
    },
    featureCategories() {
      return this.$store.state.facilityFeature.featureCategories;
    },
    loadingState() {
      return this.$store.state.facilityFeature.loadingState;
    },
    validFields() {
      return this.currentFeature.category && this.currentFeature.icon && this.currentFeature.text;
    }
  },

  components: {
    ApplicationLayout
  },

  async created() {
    await this.$store.dispatch("getFeature", this.$route.params.featureId);
  },

  methods: {
    submitEditFeatureForm() {
      if (this.$refs.editFeatureForm.validate()) {
        this.$store.dispatch("updateFeature");
      }
    }
  }
};
</script>
